import k2500FrontDesktop from "../../../assets/img/models/k2500/carousel/k2500-front-desktop.webp";
import k2500FrontMobile from "../../../assets/img/models/k2500/carousel/k2500-front-mobile.webp";
import k2500BackDesktop from "../../../assets/img/models/k2500/carousel/k2500-back-desktop.webp";
import k2500BackMobile from "../../../assets/img/models/k2500/carousel/k2500-back-mobile.webp";
import k2500SideDesktop from "../../../assets/img/models/k2500/carousel/k2500-side-desktop.webp";
import k2500SideMobile from "../../../assets/img/models/k2500/carousel/k2500-side-mobile.webp";
// k2500 hero video images
import k2500HeroVideoDesktop from "../../../assets/videos/k2500-hero-desktop.webp";
import k2500HeroVideoMobile from "../../../assets/videos/k2500-hero-mobile.mp4";
// k2500 exterior images
import k2500ExteriorSide from "../../../assets/img/models/k2500/exterior/k2500-exterior-side.webp";
import k2500ExteriorDoors from "../../../assets/img/models/k2500/exterior/k2500-exterior-doors.webp";
import k2500ExteriorHeadlights from "../../../assets/img/models/k2500/exterior/k2500-exterior-headlights.webp";
import k2500ExteriorCargo from "../../../assets/img/models/k2500/exterior/k2500-exterior-cargo.webp";
import k2500ExteriorTrunk from "../../../assets/img/models/k2500/exterior/k2500-exterior-trunk.webp";
// k2500 interior images
import k2500InteriorSteeringWheel from "../../../assets/img/models/k2500/interior/k2500-interior-steering-wheel.webp";
import k2500InteriorRadio from "../../../assets/img/models/k2500/interior/k2500-interior-radio.webp";
import k2500InteriorSeats from "../../../assets/img/models/k2500/interior/k2500-interior-seats.webp";
import k2500InteriorGearbox from "../../../assets/img/models/k2500/interior/k2500-interior-gearbox.webp";
import k2500InteriorAirConditioner from "../../../assets/img/models/k2500/interior/k2500-interior-air-conditioner.webp";
// k2500 Atributos
import k2500AtributesDesktop from "../../../assets/img/models/k2500/atributes/k2500-atributes-desktop.webp";
import k2500AtributesMobile from "../../../assets/img/models/k2500/atributes/k2500-atributes-mobile.webp";
// k2500 Etiqueta
import k2500Etiqueta from "../../../assets/etiquetas/Etiqueta K2500 CS.pdf";
// k2500 Fichas
import k2500Fichas from "../../../assets/fichas/Ficha técnica K2500 CS.pdf";
// k2500 colors images
import k2500White from "../../../assets/img/models/k2500/colors/k2500-white.webp";

export const k2500Images = {
  carousel: {
    front: {
      desktop: k2500FrontDesktop,
      mobile: k2500FrontMobile,
    },
    back: {
      desktop: k2500BackDesktop,
      mobile: k2500BackMobile,
    },
    side: {
      desktop: k2500SideDesktop,
      mobile: k2500SideMobile,
    },
  },
  exterior: {
    side: {
      desktop: k2500ExteriorSide,
      mobile: k2500ExteriorSide,
    },
    doors: {
      desktop: k2500ExteriorDoors,
      mobile: k2500ExteriorDoors,
    },
    headlights: {
      desktop: k2500ExteriorHeadlights,
      mobile: k2500ExteriorHeadlights,
    },
    cargo: {
      desktop: k2500ExteriorCargo,
      mobile: k2500ExteriorCargo,
    },
    trunk: {
      desktop: k2500ExteriorTrunk,
      mobile: k2500ExteriorTrunk,
    },
  },
  interior: {
    steeringWheel: {
      desktop: k2500InteriorSteeringWheel,
      mobile: k2500InteriorSteeringWheel,
    },
    radio: {
      desktop: k2500InteriorRadio,
      mobile: k2500InteriorRadio,
    },
    seats: {
      desktop: k2500InteriorSeats,
      mobile: k2500InteriorSeats,
    },
    gearbox: {
      desktop: k2500InteriorGearbox,
      mobile: k2500InteriorGearbox,
    },
    airConditioner: {
      desktop: k2500InteriorAirConditioner,
      mobile: k2500InteriorAirConditioner,
    },
  },
  colors: {
    white: k2500White,
  },
  heroVideo: {
    desktop: k2500HeroVideoDesktop,
    mobile: k2500HeroVideoMobile,
  },
  attributes: {
    desktop: k2500AtributesDesktop,
    mobile: k2500AtributesMobile,
  },
  etiqueta: k2500Etiqueta,
  fichas: k2500Fichas,
};
